import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicMarieStopesBenin from "../Components/ProjPicMarieStopesBenin";

const ProjectPageMarieStopesBenin = () => {
    return (
        <>
            <Navbar />
            <ProjPicMarieStopesBenin />
            <Footer />
        </>
    );
};

export default ProjectPageMarieStopesBenin;
